module.exports = __webpack_public_path__ + "img/ep-nuage.64d1da5d.jpg";